/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { documentsBatchIndex } from "../../funcs/documentsBatchIndex.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.BatchIndexTextRequest$inboundSchema,
};

export const tool$documentsBatchIndex: ToolDefinition<typeof args> = {
  name: "documents-batch-index",
  description: `Batch index text documents

Batch index text documents. Limited to 100 documents per batch.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await documentsBatchIndex(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(void 0, apiCall);
  },
};
